import { useContext, useEffect } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import { useQueryAttributes } from './useQueryAttributes';
import { getQueryFromAttributes, getQueryType } from './getQueryFromAttributes';
import QueryContext from '../QueryContext';
import { useDataModel } from './useDataModel';

const defaultOptionsFn = ({ options }) => options;

export const useLazyDataModel = (queryName, opts) => {

  const [exec, response, cachedVariables] = useDataModel(queryName, opts, true);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS && response.data && !response.loading) {
      const { data } = response;

      window.LIFE_CYCLE_EVENT_BUS.trigger('data-sources.data', {
        type: 'product',
        variables: opts.variables,
        data
      });
    }
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS && response.error && !response.loading) {
      const { data } = response;

      window.LIFE_CYCLE_EVENT_BUS.trigger('data-sources.error', {
        type: 'product',
        variables: opts.variables,
        data
      });
    }
  }, [response?.loading]);

  return [exec, response, cachedVariables];
};
